import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Nav, Navbar, Container } from "react-bootstrap";
import { webSiteUrl, myFetchPost, apiUrl } from "../utility/index";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const MainHeader = ({ unReadCounter, hiddenMobile }) => {
  const { currentUser, authSignOut } = useAuth();

  useEffect(() => {
    const fcmTokenTimestamp = window.localStorage.getItem("fcmTokenTimestamp");
    const pushnotification = window.localStorage.getItem("pushnotification");
    const previousToken = window.localStorage.getItem("fcmToken");

    if (pushnotification) {
      const messaging = getMessaging();
      if (Notification.permission === "granted") {
        getToken(messaging, {
          vapidKey:
            "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
        })
          .then((currentToken) => {
            if (currentUser?.uid) {
              /* also update the fcmToken & user_id associations */
              /* update the fcm & user_id association */
              currentUser.getIdToken().then(async (token) => {
                const requestData = {
                  form_action: "subscribe",
                  currentToken: currentToken,
                  previousToken: previousToken,
                  platform: "webapp",
                };
                const data = await myFetchPost(`${apiUrl}/notification/subscribe`, requestData, {
                  Authorization: "Bearer " + token,
                });
                window.localStorage.setItem('fcmTokenTimestamp', Math.floor(Date.now() / 1000));
                window.localStorage.setItem('fcmToken', currentToken);
              });
            } else {
              /* cancel the subscription if not logged in */
              const requestData = {
                form_action: "cancelsubscription",
                currentToken: currentToken,
                previousToken: previousToken,
                platform: "webapp",
              };

              return myFetchPost(`${apiUrl}/notification/initializewithnouser`, requestData, {
                Authorization: "Bearer ",
              }).then(data => {
                window.localStorage.setItem('fcmTokenTimestamp', Math.floor(Date.now() / 1000));
                window.localStorage.setItem('fcmToken', currentToken);
              });
            }
          }).catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });
        }
    }


  }, [currentUser]);

  const handleLogout = () => {
    if (window.confirm("你是否確定登出?")) {
      authSignOut("signout successful").then(() => {
        /* also signout dcfever */
        const formData = new FormData();
        formData.append("grant_type", "signout");

        const requestOptions = {
          method: "POST",
          body: formData,
        };

        fetch(`${webSiteUrl}/app/users/login.php`, requestOptions);
      });
    }
  };

  let loginDiv = null;
  if (currentUser == null || currentUser == undefined) {
    loginDiv = (
      <Nav.Link to="/login" as={NavLink}>
        登入
      </Nav.Link>
    );
  }

  if (currentUser?.uid > 0) {
    loginDiv = (
      <Nav.Link href="#" onClick={handleLogout}>
        登出 {currentUser?.displayName}
      </Nav.Link>
    );
  }

  return (
    <>
      <Navbar
        collapseOnSelect={true}
        expand="lg"
        bg="light"
        variant="light"
        className={hiddenMobile ? 'mainHeaderWrap hiddenMobile' : 'mainHeaderWrap'}
      >
        <Container fluid="sm">
          <Navbar.Brand href="https://www.dcfever.com/index.php">
            <img
              alt=""
              src="https://cdn01.dcfever.com/images/dcfever_logo_v2_png.png"
              height="30"
              className="d-inline-block align-top"
            />{" "}
          </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="https://www.dcfever.com/trading/index.php">
              <span className="navSubHeader">二手市集</span>
            </Nav.Link>
          </Nav>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Nav.Link to="/" as={NavLink} href="#">
                <div className="navLink">
                  所有對話
                  {unReadCounter > 0 ? (
                    <div className="unReadCounter">
                      {unReadCounter > 9 ? "9+" : unReadCounter}
                    </div>
                  ) : null}
                </div>
              </Nav.Link>
              <Nav.Link to="/settings" as={NavLink} href="#">
                通知選項
              </Nav.Link>
              {/* <Nav.Link href="https://www.dcfever.com/trading/index.php">
                二手市集
              </Nav.Link> */}
              <Nav.Link href="https://www.dcfever.com/trading/manage.php">
                買賣助理
              </Nav.Link>
              {loginDiv}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};
export default MainHeader;
